/* eslint-disable comma-dangle, no-var, react/forbid-prop-types, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");

var _require = require("aphrodite"),
    StyleSheet = _require.StyleSheet,
    css = _require.css;

var _ = require("underscore");

var Renderer = require("../renderer.jsx");
var Sortable = require("../components/sortable.jsx");

var ApiOptions = require("../perseus-api.jsx").Options;
var shuffle = require("../util.js").shuffle;
var seededRNG = require("../util.js").seededRNG;

var _require2 = require("../gorgon/proptypes.js"),
    linterContextProps = _require2.linterContextProps,
    linterContextDefault = _require2.linterContextDefault;

var HACKY_CSS_CLASSNAME = "perseus-widget-matcher";

var Matcher = React.createClass({
    displayName: "Matcher",

    propTypes: {
        apiOptions: ApiOptions.propTypes,
        labels: React.PropTypes.array,
        left: React.PropTypes.array,
        onChange: React.PropTypes.func,
        orderMatters: React.PropTypes.bool,
        padding: React.PropTypes.bool,
        problemNum: React.PropTypes.number,
        right: React.PropTypes.array,
        trackInteraction: React.PropTypes.func.isRequired,
        linterContext: linterContextProps
    },

    getDefaultProps: function getDefaultProps() {
        return {
            left: [],
            right: [],
            labels: ["", ""],
            orderMatters: false,
            padding: true,
            problemNum: 0,
            onChange: function onChange() {},
            linterContext: linterContextDefault
        };
    },

    getInitialState: function getInitialState() {
        return {
            leftHeight: 0,
            rightHeight: 0
        };
    },

    render: function render() {
        // Use the same random() function to shuffle both columns sequentially
        var rng = seededRNG(this.props.problemNum);

        var left;
        if (!this.props.orderMatters) {
            // If the order doesn't matter, don't shuffle the left column
            left = this.props.left;
        } else {
            left = shuffle(this.props.left, rng, /* ensurePermuted */true);
        }

        var right = shuffle(this.props.right, rng, /* ensurePermuted */true);

        var showLabels = _.any(this.props.labels);
        var constraints = {
            height: _.max([this.state.leftHeight, this.state.rightHeight])
        };

        var cellMarginPx = this.props.apiOptions.isMobile ? 8 : 5;

        return React.createElement(
            "table",
            { className: css(styles.widget) + " " + HACKY_CSS_CLASSNAME },
            React.createElement(
                "tbody",
                null,
                showLabels && React.createElement(
                    "tr",
                    { className: css(styles.row) },
                    React.createElement(
                        "th",
                        {
                            className: css(styles.column, styles.columnLabel)
                        },
                        React.createElement(Renderer, {
                            content: this.props.labels[0] || "...",
                            linterContext: this.props.linterContext
                        })
                    ),
                    React.createElement(
                        "th",
                        {
                            className: css(styles.column, styles.columnRight, styles.columnLabel)
                        },
                        React.createElement(Renderer, {
                            content: this.props.labels[1] || "...",
                            linterContext: this.props.linterContext
                        })
                    )
                ),
                React.createElement(
                    "tr",
                    { className: css(styles.row) },
                    React.createElement(
                        "td",
                        { className: css(styles.column) },
                        React.createElement(Sortable, {
                            options: left,
                            layout: "vertical",
                            padding: this.props.padding,
                            disabled: !this.props.orderMatters,
                            constraints: constraints,
                            onMeasure: this.onMeasureLeft,
                            onChange: this.changeAndTrack,
                            margin: cellMarginPx,
                            linterContext: this.props.linterContext,
                            ref: "left"
                        })
                    ),
                    React.createElement(
                        "td",
                        { className: css(styles.column, styles.columnRight) },
                        React.createElement(Sortable, {
                            options: right,
                            layout: "vertical",
                            padding: this.props.padding,
                            constraints: constraints,
                            onMeasure: this.onMeasureRight,
                            onChange: this.changeAndTrack,
                            margin: cellMarginPx,
                            linterContext: this.props.linterContext,
                            ref: "right"
                        })
                    )
                )
            )
        );
    },

    changeAndTrack: function changeAndTrack(e) {
        this.props.onChange(e);
        this.props.trackInteraction();
    },

    onMeasureLeft: function onMeasureLeft(dimensions) {
        var height = _.max(dimensions.heights);
        this.setState({ leftHeight: height });
    },

    onMeasureRight: function onMeasureRight(dimensions) {
        var height = _.max(dimensions.heights);
        this.setState({ rightHeight: height });
    },

    getUserInput: function getUserInput() {
        return {
            left: this.refs.left.getOptions(),
            right: this.refs.right.getOptions()
        };
    },

    simpleValidate: function simpleValidate(rubric) {
        return Matcher.validate(this.getUserInput(), rubric);
    }
});

_.extend(Matcher, {
    validate: function validate(state, rubric) {
        var correct = _.isEqual(state.left, rubric.left) && _.isEqual(state.right, rubric.right);

        return {
            type: "points",
            earned: correct ? 1 : 0,
            total: 1,
            message: null
        };
    }
});

var padding = 5;
var border = "1px solid #444";

var styles = StyleSheet.create({
    widget: {
        paddingTop: padding,
        maxWidth: "100%",

        // Need to override minWidth in CSS :(
        minWidth: "auto"
    },

    row: {
        // Need to override global rules in CSS :(
        border: 0
    },

    column: {
        // TODO(benkomalo): constraint to half width?
        padding: 0,
        border: 0
    },

    columnRight: {
        borderLeft: border
    },

    columnLabel: {
        fontWeight: "inherit",
        borderBottom: border,
        padding: "0 " + padding + "px " + padding + "px " + padding + "px",
        textAlign: "center"
    }
});

module.exports = {
    name: "matcher",
    displayName: "Two column matcher",
    widget: Matcher,
    isLintable: true
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/matcher.jsx
 ** module id = 124
 ** module chunks = 0 1
 **/